import { ACTIVITY_PASS, AGENCY, locationIsUnder, locationsAreEqual, R1S_LOCATION_ID, ROOT } from './locations';

export const PMO = 'ROLE_PMO';
export const BAH_ADMIN = 'ROLE_BAH_ADMIN';
export const ATR = 'ROLE_ATR';
export const FACILITY_MANAGER = 'ROLE_FACILITY_MANAGER';
export const FACILITY_OPERATOR = 'ROLE_FACILITY_OPERATOR';
export const ATTENDANT = 'ROLE_ATTENDANT';
export const HOST = 'ROLE_HOST';
export const COOPERATOR = 'ROLE_COOPERATOR';
export const USGS_ROLE = 'ROLE_USGS';
export const FINANCE_ADMIN = 'ROLE_FINANCE_ADMIN';
export const FINANCE_USER = 'ROLE_FINANCE_USER';
export const CSR2 = 'ROLE_CSR2';
export const CSR1 = 'ROLE_CSR';
export const SUPER_USER = 'ROLE_SUPER_USER';
export const SYSTEM_USER = 'ROLE_SYSTEM_USER';
export const BAH_FINANCE = 'ROLE_BAH_FINANCE';
export const PASS_OPERATOR = 'ROLE_PASS_OPERATOR';
export const REPORT_ONLY = 'ROLE_REPORT_ONLY';
export const CSR_SUPERVISOR = 'ROLE_CSR_SUPERVISOR';

export const USGS_LOCATION_ID = '200000';
export const VEHICLE_PERMIT = 'Vehicle Permit';
export const PERMIT = 'Permit';
export const TICKET_FACILITY = 'Ticket Facility';
export const TIMED_ENTRY = 'Timed Entry';
export const CAMPGROUND = 'Campground';
export const ALL_ROLES = [
  PMO,
  BAH_ADMIN,
  ATR,
  FACILITY_MANAGER,
  FACILITY_OPERATOR,
  ATTENDANT,
  HOST,
  COOPERATOR,
  USGS_ROLE,
  FINANCE_ADMIN,
  FINANCE_USER,
  CSR1,
  BAH_FINANCE,
  PASS_OPERATOR,
];
export const ALL_ROLES_ORDERED = [
  PMO,
  BAH_ADMIN,
  CSR_SUPERVISOR,
  ATR,
  FACILITY_MANAGER,
  FACILITY_OPERATOR,
  ATTENDANT,
  HOST,
  PASS_OPERATOR,
  COOPERATOR,
  FINANCE_ADMIN,
  FINANCE_USER,
  CSR2,
  CSR1,
  USGS_ROLE,
  BAH_FINANCE,
];
export const COMM_EMAIL_ROLES = [FACILITY_MANAGER, FACILITY_OPERATOR, ATTENDANT, HOST];
export const LOCATION_LEAF_TYPES = [PERMIT, TICKET_FACILITY, CAMPGROUND];

export const AllRoleTypesObj = {
  PMO,
  BAH_ADMIN,
  ATR,
  FACILITY_MANAGER,
  FACILITY_OPERATOR,
  ATTENDANT,
  HOST,
  COOPERATOR,
  USGS_ROLE,
  FINANCE_ADMIN,
  FINANCE_USER,
  CSR1,
  CSR2,
  CSR_SUPERVISOR,
  SUPER_USER,
  BAH_FINANCE,
  PASS_OPERATOR,
  REPORT_ONLY,
};

export const AllLeafTypesObj = {
  VEHICLE_PERMIT,
  PERMIT,
  TICKET_FACILITY,
  TIMED_ENTRY,
  CAMPGROUND,
  ACTIVITY_PASS,
};

export const AllLeafTypesArr = [VEHICLE_PERMIT, PERMIT, TICKET_FACILITY, TIMED_ENTRY, CAMPGROUND, ACTIVITY_PASS];

export const roleTypeToDisplayMap = {
  ROLE_PMO: 'PMO',
  ROLE_BAH_ADMIN: 'BAH Admin',
  ROLE_ATR: 'APM',
  ROLE_FACILITY_MANAGER: 'Facility Management',
  ROLE_FACILITY_OPERATOR: 'Facility Operations',
  ROLE_ATTENDANT: 'Attendant',
  ROLE_HOST: 'Host',
  ROLE_COOPERATOR: 'Cooperator',
  ROLE_USGS: 'USGS',
  ROLE_FINANCE_ADMIN: 'Finance Admin',
  ROLE_FINANCE_USER: 'Finance User',
  ROLE_CSR: 'CSR',
  ROLE_CSR2: 'CSR2',
  ROLE_CSR_SUPERVISOR: 'CSR Supervisor',
  ROLE_SUPER_USER: 'Super User',
  ROLE_SYSTEM_USER: 'System User',
  ROLE_BAH_FINANCE: 'Booz Allen Finance',
  ROLE_PASS_OPERATOR: 'Pass Operations',
  ROLE_REPORT_ONLY: 'Report Only',
};

export const leafTypeToDisplayMap = {
  PERMIT: 'Permit',
  TICKET_FACILITY: 'Ticket Facility',
  CAMPGROUND: 'Campground',
  ACTIVITY_PASS: 'Activity Pass',
};

export const optionForExistingRole = (options, assignedLocation, existingRoles, isEditingSelf) => {
  let result = '';

  // Check each existing role to find one at this location
  for (const role of existingRoles) {
    if (
      role.location.location_id === assignedLocation.location_id &&
      role.location.location_type === assignedLocation.location_type
    ) {
      // Check each option to find the one that equals this role type
      for (const option of options) {
        if (option.value === role.role_type) {
          // This is the option for assigned role at this location
          result = option;
        }
      }

      if (isEditingSelf && !result && role.role_type === ATR) {
        result = { value: ATR, label: 'Level 1 - APM' };
      }

      break;
    }
  }

  return result;
};

export const roleIsUnder = (childRole, parentRole) => {
  if (parentRole.role_type === SUPER_USER) {
    return true;
  }

  switch (childRole.role_type) {
    case CSR1:
      return parentRole.role_type === CSR1;
    case CSR2:
      return parentRole.role_type === CSR2;
    case PMO:
      // a PMO has authority over other PMOs.
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case CSR_SUPERVISOR:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case ATR:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case FINANCE_ADMIN:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case FINANCE_USER:
      return (
        parentRole.role_type === FINANCE_ADMIN ||
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case FACILITY_MANAGER:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2 ||
        parentRole.role_type === FACILITY_MANAGER
      );
    case FACILITY_OPERATOR:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case ATTENDANT:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === FACILITY_OPERATOR ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case HOST:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === FACILITY_OPERATOR ||
        parentRole.role_type === ATTENDANT ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case COOPERATOR:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === FACILITY_OPERATOR ||
        parentRole.role_type === ATTENDANT ||
        parentRole.role_type === CSR1 ||
        parentRole.role_type === CSR2
      );
    case BAH_FINANCE:
      // Can only be created by Super User, so can only be edited by them.
      // just being explicit.
      return false;
    case PASS_OPERATOR:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === CSR2
      );
    case USGS_ROLE:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === CSR2 ||
        parentRole === SUPER_USER
      );
    case REPORT_ONLY:
      return (
        parentRole.role_type === PMO ||
        parentRole.role_type === BAH_ADMIN ||
        parentRole.role_type === ATR ||
        parentRole.role_type === FACILITY_MANAGER ||
        parentRole.role_type === CSR2
      );
    default:
      return false;
  }
};

export const highestRoleAtLocation = (managerRoles, location) => {
  const managingRolesForLocation = [];

  for (const managerRole of managerRoles) {
    if (locationIsUnder(location, managerRole.location) || locationsAreEqual(managerRole.location, location)) {
      managingRolesForLocation.push(managerRole);
    }
  }

  if (managingRolesForLocation.length === 0) {
    return managerRoles[0];
  }

  let highestRole = managingRolesForLocation[0];
  for (const managingRole of managingRolesForLocation) {
    if (
      managingRole.role_type === highestRole.role_type &&
      locationIsUnder(highestRole.location, managingRole.location)
    ) {
      highestRole = managingRole;
    } else {
      const isUnder = roleIsUnder(highestRole, managingRole);
      if (isUnder) {
        highestRole = managingRole;
      }
    }
  }

  return highestRole;
};

export const displayStringForRoleType = (roleType) => {
  let displayString = roleTypeToDisplayMap[roleType];

  if (!displayString) {
    // TODO need confirmation on this from UI
    console.log('roleType unhandled', roleType); // TODO Remove
    displayString = 'N/A';
  }

  return displayString;
};

export const getFlagValue = (allFlags, flagNameToFind) => {
  if (!allFlags?.FeatureFlags) {
    return false;
  }

  for (const flag of allFlags.FeatureFlags) {
    if (flag.flag_name === flagNameToFind) {
      return flag.value;
    }
  }
  return false;
};

export const roleDropdownOptionsForLocation = (managerRoles, assignedLocation, isEditingSelf) => {
  let result = [];

  const allOptions = {
    SuperUser: { value: SUPER_USER, label: 'Super User', order: 0 },
    PMO: { value: PMO, label: displayStringForRoleType(PMO), order: 1 },
    APM: { value: ATR, label: 'Level 1 - APM', order: 2 },
    FacilityManager: { value: FACILITY_MANAGER, label: 'Level 2 - Facility Management', order: 3 },
    FacilityOperator: { value: FACILITY_OPERATOR, label: 'Level 3 - Facility Operations', order: 4 },
    Attendant: { value: ATTENDANT, label: 'Level 4 - Attendant', order: 5 },
    Host: { value: HOST, label: 'Level 5 - Host', order: 6 },
    ReportOnly: { value: REPORT_ONLY, label: 'Report Only', order: 7 },
    PassOperator: { value: PASS_OPERATOR, label: displayStringForRoleType(PASS_OPERATOR), order: 8 },
    FinanceAdmin: { value: FINANCE_ADMIN, label: displayStringForRoleType(FINANCE_ADMIN), order: 9 },
    FinanceUser: { value: FINANCE_USER, label: displayStringForRoleType(FINANCE_USER), order: 10 },
    USGS: { value: USGS_ROLE, label: 'USGS', order: 11 },
    BahAdmin: { value: BAH_ADMIN, label: 'BAH Admin', order: 12 },
    BahFinance: { value: BAH_FINANCE, label: 'Booz Allen Finance', order: 13 },
    CSRSupervisor: { value: CSR_SUPERVISOR, label: 'CSR Supervisor', order: 14 },
    CSR1: { value: CSR1, label: displayStringForRoleType(CSR1), order: 15 },
    CSR2: { value: CSR2, label: 'CSR2', order: 16 },
    SystemUser: { value: SYSTEM_USER, label: 'System User', order: 17 },
  };

  const dropDownOptions = [
    allOptions.FacilityManager,
    allOptions.FacilityOperator,
    allOptions.Attendant,
    allOptions.Host,
  ];

  const highestRole = highestRoleAtLocation(managerRoles, assignedLocation);
  switch (highestRole.role_type) {
    case SUPER_USER:
      result = dropDownOptions;

      if (assignedLocation.location_id === R1S_LOCATION_ID && assignedLocation.location_type === ROOT) {
        result.unshift(allOptions.PMO);
        result.unshift(allOptions.BahAdmin);
        result.unshift(allOptions.SystemUser);
        result.push(allOptions.ReportOnly);
        result.push(allOptions.FinanceAdmin);
        result.push(allOptions.BahFinance);
        result.push(allOptions.FinanceUser);
        result.push(allOptions.CSRSupervisor);
        result.push(allOptions.CSR2);
        result.push(allOptions.CSR1);
      } else if (assignedLocation.location_type === AGENCY) {
        result.unshift(allOptions.APM);
        result.push(allOptions.CSRSupervisor);
        result.push(allOptions.CSR2);
        result.push(allOptions.CSR1);
      } else {
        result.push(allOptions.ReportOnly);
      }

      break;
    case CSR1:
    case CSR2:
    case CSR_SUPERVISOR:
      if (isEditingSelf) {
        result = [allOptions.CSR1];
        break;
      }

      result = dropDownOptions;

      if (assignedLocation.location_id === R1S_LOCATION_ID) {
        result.push(allOptions.CSR1);
      }

      if (assignedLocation.location_type === AGENCY) {
        result.unshift(allOptions.APM);
      }

      break;
    case PMO:
    case BAH_ADMIN:
      result = dropDownOptions;

      if (assignedLocation.location_type === AGENCY) {
        result.unshift(allOptions.APM);
      } else if (assignedLocation.location_id === R1S_LOCATION_ID && isEditingSelf) {
        if (highestRole.role_type === PMO) {
          result.unshift(allOptions.PMO);
        }
        if (highestRole.role_type === BAH_ADMIN) {
          result.unshift(allOptions.BahAdmin);
        }
      }

      break;
    case ATR:
      result = dropDownOptions;
      break;
    case FACILITY_MANAGER:
      result = dropDownOptions;
      break;
    case FACILITY_OPERATOR:
      result = dropDownOptions.slice(isEditingSelf ? 1 : 2);
      break;
    case ATTENDANT:
      result = dropDownOptions.slice(isEditingSelf ? 2 : 3);
      break;
    case HOST:
      result = dropDownOptions.slice(isEditingSelf ? 3 : 4);
      break;
    default:
      break;
  }

  if (highestRole.role_type === CSR2 && isEditingSelf) {
    result.push(allOptions.CSR2);
  }

  if (
    (highestRole.role_type === SUPER_USER || highestRole.role_type === PMO || highestRole.role_type === BAH_ADMIN) &&
    assignedLocation.location_id === USGS_LOCATION_ID
  ) {
    result.push(allOptions.USGS);
  }

  // FM+ can create ROLE_REPORT_ONLY
  if (
    highestRole.role_type === ATR ||
    highestRole.role_type === BAH_ADMIN ||
    highestRole.role_type === PMO ||
    highestRole.role_type === CSR2 ||
    highestRole.role_type === FACILITY_MANAGER
  ) {
    result.push(allOptions.ReportOnly);
  }

  if (
    highestRole.role_type === FINANCE_ADMIN &&
    assignedLocation.location_id === R1S_LOCATION_ID &&
    assignedLocation.location_type === ROOT
  ) {
    result.push(allOptions.FinanceUser);
  }

  // FO+ can create pass operator
  if (
    assignedLocation.has_park_pass &&
    (highestRole.role_type === SUPER_USER ||
      highestRole.role_type === PMO ||
      highestRole.role_type === BAH_ADMIN ||
      highestRole.role_type === ATR ||
      highestRole.role_type === FACILITY_MANAGER ||
      highestRole.role_type === FACILITY_OPERATOR)
  ) {
    result.push(allOptions.PassOperator);
  }

  return result;
};

export const doesUserHaveRoleType = (user, roleType) => {
  for (const userRole of user.roles) {
    if (userRole.role_type === roleType) {
      return true;
    }
  }

  return false;
};

export const userCanEditUser = (actor, user) => {
  let canEdit = false;

  if (user && user.roles && actor && actor.roles) {
    for (const actorRole of actor.roles) {
      if (actorRole.role_type === SUPER_USER) {
        return doesUserHaveRoleType(actor, SUPER_USER);
      }

      if (actorRole.role_type === CSR1) {
        return false;
      }

      for (const userRole of user.roles) {
        const locationUnder = locationIsUnder(userRole.location, actorRole.location);
        const locationEqual = locationsAreEqual(userRole.location, actorRole.location);
        const locCheck =
          locationUnder ||
          (locationEqual &&
            (userRole.role_type !== PMO || userRole.role_type !== BAH_ADMIN) &&
            userRole.role_type !== ATR);

        if (roleIsUnder(userRole, actorRole) && locCheck) {
          canEdit = true;
        }
      }
    }
  }

  return canEdit;
};

export const simplifyRolesLocationObject = (roles) => {
  if (roles) {
    const simplifiedRoles = roles.map((role) => {
      return {
        ...role,
        location: {
          location_id: role.location.location_id,
          location_type: role.location.location_type,
          has_lottery: role.location.has_lottery,
          has_cooperators: role.location.has_cooperators,
        },
      };
    });
    return simplifiedRoles;
  }
  return roles;
};
